module.exports = __webpack_public_path__ + "static/media/buildingOverdue.6b34d087.svg";